<template>
  <v-expansion-panel>
    <v-expansion-panel-header>Indisponibilidade</v-expansion-panel-header>

    <v-expansion-panel-content>
      <agenda-indisponibilidade-form
        :indisponibilidade-selecionada="indisponibilidadeSelecionada"
        :agente-id="agenteId"
        :pode-editar="podeEditar"
        @refetch-data="handleRefetchData"
      />

      <agenda-indisponibilidade-table
        class="mt-4"
        :items="indisponibilidadesDoAgente"
        :loading="isGetIndisponibilidadesLoading"
        :pode-editar="podeEditar"
        @update:indisponibilidade-selecionada="v => indisponibilidadeSelecionada = v"
        @excluir-indisponibilidade="resetIndisponibilidadeSelecionadaERefetchData"
      />
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { ref } from '@vue/composition-api'
import AgendaIndisponibilidadeForm from './AgendaIndisponibilidadeForm.vue'
import AgendaIndisponibilidadeTable from './AgendaIndisponibilidadeTable.vue'

export default {
  emits: ['refetch-data'],

  components: {
    AgendaIndisponibilidadeForm,
    AgendaIndisponibilidadeTable,
  },

  props: {
    indisponibilidadesDoAgente: {
      type: Array,
      required: true,
    },
    isGetIndisponibilidadesLoading: Boolean,
    // NOVAS PROPS OBRIGATÓRIAS
    agenteId: {
      type: Number,
      required: true,
    },
    podeEditar: {
      type: Boolean,
      default: false,
    },
  },

  setup(_, { emit }) {
    const indisponibilidadeSelecionada = ref(null)

    function handleRefetchData() {
      indisponibilidadeSelecionada.value = null
      emit('refetch-data')
    }

    function resetIndisponibilidadeSelecionadaERefetchData(id) {
      if (indisponibilidadeSelecionada.value?.id === id) {
        indisponibilidadeSelecionada.value = null
      }

      emit('refetch-data')
    }

    return {
      indisponibilidadeSelecionada,
      handleRefetchData,
      resetIndisponibilidadeSelecionadaERefetchData,
    }
  },
}
</script>
